import axios from 'axios';

export function resetPassword(email: string) {
  return axios.post('/send_reset_password_email', {
    email,
  });
}
